import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import styled from "styled-components";

type AppLogoProps = {
	collapsed: boolean;
	onCollapse?: () => void;
	onClick?: () => void;
};

const AppLogo: React.FC<AppLogoProps> = ({ collapsed, onCollapse, onClick }) => {
	return (
		<LogoContainer collapsed={collapsed}>
			{collapsed ? (
				<AppAvatar2>
					<img
						src={process.env.PUBLIC_URL + "/baloon-2.png"}
						alt="Logo"
						onClick={onClick}
						style={{ cursor: onClick ? 'pointer' : 'default' }}
					/>
				</AppAvatar2>
			) : (
				// <AppTitle>{process.env.REACT_APP_WEBSITE_NAME} jj</AppTitle>
				<AppAvatar2>
					<img
						src={process.env.PUBLIC_URL + "/baloon-2.png"}
						alt="Logo"
						onClick={onClick}
						style={{ cursor: onClick ? 'pointer' : 'default' }}
					/>
				</AppAvatar2>
			)}
			<Button
				onClick={onCollapse}
				className="hide-lg"
				type="ghost"
				icon={<CloseOutlined />}
			/>
		</LogoContainer>
	);
};

type LogoContainerProps = {
	collapsed: boolean;
};

const LogoContainer = styled.div<LogoContainerProps>`
	padding: ${({ collapsed }) => (collapsed ? "0" : "0 16px")};
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: ${({ collapsed }) => (collapsed ? "center" : "space-between")};
	background-color: ${({ theme }) => theme.colors.primary};
`;

const AppTitle = styled.div`
	color: ${({ theme }) => theme.colors.white};
	font-size: 20px;
	font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const AppAvatar = styled.div`
	background-color: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.white};
	font-weight: ${({ theme }) => theme.fontWeight.bold};
	height: 40px;
`;

const AppAvatar2 = styled.div`
	background-color: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.white};
	font-weight: ${({ theme }) => theme.fontWeight.bold};
	height: 60px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 16px;
`;

export default AppLogo;
